import { CooperativesActionTypes } from './action-types';
import { CooperativesState } from 'models';
import { Reducer } from 'redux';

const initialState: CooperativesState = {
  cooperativesList: [],
  loading: false,
  error: false,
};

export const reducer: Reducer<CooperativesState> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case CooperativesActionTypes.REQUEST_COOPERATIVES_START:
      return { ...state, loading: true, error: false };
    case CooperativesActionTypes.REQUEST_COOPERATIVES_SUCCESS:
      return { ...state, loading: false, cooperativesList: action.payload };
    case CooperativesActionTypes.REQUEST_COOPERATIVES_FAILED:
      return { ...state, loading: false, error: true };
    default:
      return state;
  }
};
